/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	
	    // Add active state to desktop navbutton
	    $('.nav__button').click(function (e) {
	        e.stopPropagation();
	
	        $(this).toggleClass('nav__button--active');
	        $('.innerbody').toggleClass('body--fixed');
	
	        // $('.menu-primary-menu-container').toggleClass('menu-primary-menu-container--active');
	        if ($('.menu-primary-menu-container').hasClass('menu-primary-menu-container--active')) {
	
	            $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active-transition');
	            setTimeout(function () {
	                $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active');
	            }, 250);
	        } else {
	            $('.menu-primary-menu-container').addClass('menu-primary-menu-container--active');
	            $('.menu-primary-menu-container').addClass('menu-primary-menu-container--active-transition');
	        }
	    });
	
	    // Add dropdown arrows to mobile nav
	    $('.menu-item-has-children > a').append('<span></span>');
	
	    // Show/Hide Sub Menus for mobile nav
	    $('.menu-item-has-children > a > span').click(function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        $(this).toggleClass('dropdown_arrow--active');
	        $(this).closest('.menu-item-has-children').toggleClass('sub-menu--active');
	    });
	
	    $('body').click(function () {
	
	        if ($('.nav__button').hasClass('nav__button--active')) {
	            $('.nav__button').removeClass('nav__button--active');
	        }
	        if ($('.innerbody').hasClass('body--fixed')) {
	            $('.innerbody').removeClass('body--fixed');
	        }
	
	        // If menu active and you click outside menu, close menu
	        if ($('.menu-primary-menu-container').hasClass('menu-primary-menu-container--active')) {
	            $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active-transition');
	            setTimeout(function () {
	                $('.menu-primary-menu-container').removeClass('menu-primary-menu-container--active');
	            }, 250);
	        }
	    });
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	
	    /*
	        Built in such a way that it remembers the menu a user has selected for a different branch for when they go back to selecting that branch. Consists of Branch selectors and menus selectors. All content loaded on page with different data id's to match the buttons.
	     */
	    //console.log('Im compiled');
	    /* MAIN Menu Nav */
	    $('.menu_main_nav li').click(function () {
	
	        removeActiveMainMenuClasses();
	        $(this).addClass('current_menu');
	
	        hideAllSubMenus();
	        $('[data-menu-id="' + $(this).attr('data-id-selector') + '"]').addClass('menu_sub_nav--active');
	        $('[data-mobile-menu-id="' + $(this).attr('data-id-selector') + '"]').addClass('menu_mobile--active');
	
	        hideAllMenus();
	        $('[data-menu-details-id=' + $(this).attr('data-id-selector') + ']').addClass('menus--active');
	
	        $('.menus--active .menu__container__fooditems').each(function () {
	
	            if ($(this).attr('data-menu-item-id') == $('.menu_sub_navitem--active').attr('data-menu-selector-id')) {
	                $(this).addClass('menu__container__fooditems--active');
	            }
	        });
	    });
	
	    /*
	        REMOVE MAIN MENU CLASSES - Branches
	    */
	    function removeActiveMainMenuClasses() {
	        $('.menu_main_nav li').removeClass('current_menu');
	    }
	
	    /*
	        HIDE ALL SUB MENUS - Hide UL
	     */
	    function hideAllMenus() {
	        $('.menus--active menu__container__fooditems').removeClass('menu__container__fooditems--active');
	        $('.menus--active').removeClass('menus--active');
	    }
	
	    /*
	        HIDE ALL SUB MENUS - Hide UL
	     */
	    function hideAllSubMenus() {
	        $('.menu_sub_nav').removeClass('menu_sub_nav--active');
	        $('.menu_mobile').removeClass('menu_mobile--active');
	    }
	
	    /*
	        REMOVE SUB MENU CLASSES - List items Breakfast/Lunch e.c.t
	    */
	    function removeActiveSubMenuClasses() {
	        $('.menu_sub_nav--active li').removeClass('menu_sub_navitem--active');
	        $('.menu_mobile').removeClass('menu_mobile--active');
	    }
	
	    /*
	        REMOVE SUB MENU CLASSES - List items Breakfast/Lunch e.c.t
	    */
	    function removeActiveMenuTypeClasses() {
	        $('.menus--active .menu__container__fooditems').removeClass('menu__container__fooditems--active');
	    }
	
	    /* SUB Menu Nav */
	    $('.menu_sub_nav li').click(function () {
	
	        removeActiveSubMenuClasses();
	        $(this).addClass('menu_sub_navitem--active');
	
	        removeActiveMenuTypeClasses();
	        $('[data-menu-item-id="' + $(this).attr('data-menu-selector-id') + '"]').addClass('menu__container__fooditems--active');
	    });
	
	    /* Mobile Menu Nav */
	    $('select.menu_mobile').change(function () {
	        removeActiveSubMenuClasses();
	        $(this).addClass('menu_mobile--active');
	        removeActiveMenuTypeClasses();
	        $('[data-menu-item-id="' + $(this).val() + '"]').addClass('menu__container__fooditems--active');
	    });
	
	    /* As the food menus are tabbed content, it's difficult to link directly to that tab. The below javascript attempts to make it easy using an anchor tag */
	    var hash = window.location.hash.substr(1);
	
	    if (hash) {
	        $('.menu_main_nav li[data-id-selector="' + hash + '"]').trigger('click');
	    }
	});

/***/ })
/******/ ]);
